/* eslint-disable */
import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';
import { ApplicationActions } from '../../../actions/application.actions';

@Component({
  selector: 'employment-info',
  template: require('./employment-info.component.html')
})

export class EmploymentInfoComponent extends BaseRoute {
  country = 'United States';

  constructor(
    injector: Injector,
    appActions: ApplicationActions) {
    super(injector);
    this.appActions = appActions;
  }

  ngOnInit() {
    if (this.flowManager.isAuthed === true) {
      this.form.buttons.inputs.back.path = '/personal-info-auth';
    }
    const steps = this.flowManager.getStepArrays('employment-info');
    this.form.stepsComplete = steps.stepsComplete;
    this.form.stepsToComplete = steps.stepsToComplete;

    this.form.buttons.inputs.next.path = `/${this.form.stepsToComplete[0].route}`;

    this.zipOriginal = this.appActions.getData(
      'EmploymentInformation.employed.address.zip',
      ''
    );
    if (this.zipOriginal.indexOf('-') >= 0) {
      this.zipOriginal = this.zipOriginal.substring(0, this.zipOriginal.indexOf('-'));
      this.appActions.setData('EmploymentInformation.employed.address.zip', this.zipOriginal);
    }
  }

  updateOptionValue(event) {

    if( event.id === 'employmentStatus' ) {
      // const defaultCountry = this.form.inputs.employmentShow.inputs[6].defaultValue;
      const defaultCountry = 'US';
      const employed = _.indexOf( ['Employed','Self employed','Student/Employed','Volunteer worker'],event.value ) > -1;

      if ( employed ) {
        this.country = this.appActions.getData('EmploymentInformation.employed.address.country');

        // REFACTOR!!! temporary fix for missing employment info
        this.appActions.setData('appState.showVal.employmentStatus_Show',true);

        if( this.country === null ){
          this.appActions.setData('EmploymentInformation.employed.address.country',defaultCountry);
        }
      } else { // REFACTOR!!! temporary fix for missing employment info
        this.appActions.setData('appState.showVal.employmentStatus_Show',false);
      }
    }
  }
}
